<div class="field">
  <ng-content select="label"></ng-content>
  <div class="field__in">
    <div class="field__input pos-r">
      <ng-content select="input"></ng-content>
    </div>
  </div>
</div>
